import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GitHubIcon, LinkedInIcon, MailIcon } from "./Icons";
import Image from "./Image";

const REVEAL_AT = 320;

export default function StickyHeader() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let frame = 0;
        const check = () => {
            frame = 0;
            setVisible(window.scrollY > REVEAL_AT);
        };
        const onScroll = () => {
            if (frame) return;
            frame = window.requestAnimationFrame(check);
        };

        check();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
            if (frame) window.cancelAnimationFrame(frame);
        };
    }, []);

    return (
        <header className={`sticky-header ${visible ? "is-visible" : ""}`} aria-hidden={!visible}>
            <div className="sticky-header__inner">
                <Link to="/" className="sticky-header__brand">
                    <Image
                        className="sticky-header__avatar"
                        src="/avatar.png"
                        alt=""
                        width={32}
                        height={32}
                        loading="eager"
                        decoding="async"
                    />
                    <span className="sticky-header__name">
                        <span className="sticky-header__name-prefix">M. Sc.</span>{" "}
                        Alexander Efremidis
                    </span>
                </Link>
                <nav className="sticky-header__actions" aria-label="Kontakt">
                    <a
                        className="sticky-header__btn sticky-header__btn--linkedin"
                        href="https://www.linkedin.com/in/alexander-efremidis/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        tabIndex={visible ? 0 : -1}
                    >
                        <LinkedInIcon />
                    </a>
                    <a
                        className="sticky-header__btn sticky-header__btn--github"
                        href="https://github.com/DeadP4xel"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="GitHub"
                        tabIndex={visible ? 0 : -1}
                    >
                        <GitHubIcon />
                    </a>
                    <a
                        className="sticky-header__btn sticky-header__btn--email"
                        href="mailto:alex@efremidis.de"
                        aria-label="E-Mail"
                        tabIndex={visible ? 0 : -1}
                    >
                        <MailIcon />
                    </a>
                </nav>
            </div>
        </header>
    );
}
